import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import StocktakesLayer from '../components/StocktakesLayer';

const StocktakesPage = () => (
  <MasterLayout pageTitle='Stocktakes'>
    <StocktakesLayer />
  </MasterLayout>
);

export default StocktakesPage;
